/* Anek Chidiya — see sections/purkal-bird.liquid.
   Three birds cross the window every so often, strung out one after another,
   each towing a line of running stitch. The animation loop only runs
   while the flock is in the air. */
(function () {
  'use strict';

  var lane = document.querySelector('[data-pk-bird]');
  if (!lane) return;
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  /* ── tune the flock here ─────────────────────────────────────────── */
  var CFG = {
    sizes: [1.05, 0.78, 0.58], // how big each bird is, lead first
    stagger: [0, 900, 1800], // ms between take-offs, so they string out
    speeds: [7400, 8800, 10200], // ms to cross; slower = further away
    gapMin: (parseFloat(lane.dataset.rest) || 14) * 1000, // shortest wait before the flock returns
    gapVar: 12000, // extra random wait on top of that
    band: [0.16, 0.66], // the slice of the screen they fly through
    thread: lane.dataset.thread !== 'false' // each bird tows a line of stitch
  };
  /* ────────────────────────────────────────────────────────────────── */

  var thread = document.querySelector('.pk-bird-thread');
  var tpaths = thread ? thread.querySelectorAll('path') : [];
  if (!tpaths.length) CFG.thread = false;
  var W = innerWidth, H = innerHeight;

  function measure() {
    W = innerWidth;
    H = innerHeight;
    if (thread) {
      thread.setAttribute('viewBox', '0 0 ' + W + ' ' + H);
      thread.setAttribute('width', W);
      thread.setAttribute('height', H);
    }
  }

  /* Each bird is pieced from four fabrics — mustard polka, sage stripe,
     indigo cross-hatch, red stripe — with a maroon running stitch at every
     edge. Defined once in a hidden svg and borrowed by all three birds;
     repeating the <defs> in each one would duplicate the ids. */
  var PATTERNS =
    '<defs>' +
    '<pattern id="pkGold" width="9" height="9" patternUnits="userSpaceOnUse" patternTransform="rotate(28)">' +
    '<rect width="9" height="9" fill="#D6A13B"/><circle cx="4.5" cy="4.5" r="1.5" fill="#FBF6EB" opacity=".75"/></pattern>' +
    '<pattern id="pkSage" width="7" height="7" patternUnits="userSpaceOnUse" patternTransform="rotate(-16)">' +
    '<rect width="7" height="7" fill="#5C7A54"/><path d="M0 3.5h7" stroke="#FBF6EB" stroke-width="1.6" opacity=".6"/></pattern>' +
    '<pattern id="pkIndigo" width="8" height="8" patternUnits="userSpaceOnUse" patternTransform="rotate(40)">' +
    '<rect width="8" height="8" fill="#33506B"/><path d="M0 0l8 8M8 0l-8 8" stroke="#FBF6EB" stroke-width="1" opacity=".45"/></pattern>' +
    '<pattern id="pkRed" width="8" height="8" patternUnits="userSpaceOnUse">' +
    '<rect width="8" height="8" fill="#B8382A"/><path d="M0 2h8M0 6h8" stroke="#FBF6EB" stroke-width="1.3" opacity=".55"/></pattern>' +
    '</defs>';

  var S = 'stroke="#771619" stroke-linejoin="round"';

  var BIRD =
    /* far wing, behind the body */
    '<path class="pk-wf" d="M60 50 C 68 38, 82 28, 98 31 C 95 45, 82 57, 66 57 Z" ' +
    'fill="url(#pkIndigo)" ' + S + ' stroke-dasharray="3.6 3" stroke-width="1.6"/>' +
    /* tail */
    '<path d="M86 53 C 99 47, 111 49, 118 55 C 110 62, 97 66, 86 61 Z" ' +
    'fill="url(#pkRed)" ' + S + ' stroke-dasharray="3.6 3" stroke-width="1.6"/>' +
    /* body */
    '<path d="M32 47 C 30 34, 44 26, 58 27 C 76 28, 90 38, 90 50 ' +
    'C 90 63, 74 71, 58 70 C 42 69, 33 59, 32 47 Z" ' +
    'fill="url(#pkGold)" ' + S + ' stroke-dasharray="4 3.2" stroke-width="2"/>' +
    /* beak */
    '<path d="M33 44 L 15 49.5 L 33 55 Z" fill="#B8382A" ' + S + ' stroke-width="1.5"/>' +
    /* eye */
    '<circle cx="45" cy="41" r="5" fill="#FBF6EB" stroke="#771619" stroke-width="1.4"/>' +
    '<circle cx="44.2" cy="41" r="2.2" fill="#2A2118"/>' +
    /* near wing, sweeping up and behind so it never covers her face */
    '<path class="pk-wn" d="M58 48 C 61 29, 75 13, 94 11 C 96 28, 86 46, 67 53 Z" ' +
    'fill="url(#pkSage)" ' + S + ' stroke-dasharray="3.6 3" stroke-width="1.8"/>' +
    '<path class="pk-wn" d="M66 46 C 72 34, 80 24, 90 19" fill="none" ' +
    'stroke="#FBF6EB" stroke-width="1.2" stroke-dasharray="2.6 2.6" opacity=".7"/>';

  var BASE_W = 96; // her width at scale 1

  var defs = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  defs.setAttribute('width', '0');
  defs.setAttribute('height', '0');
  defs.setAttribute('aria-hidden', 'true');
  defs.style.cssText = 'position:absolute';
  defs.innerHTML = PATTERNS;
  lane.appendChild(defs);

  function hatch(scale) {
    var el = document.createElement('div');
    el.className = 'pk-bird';
    el.innerHTML = '<svg viewBox="0 0 120 92" focusable="false">' + BIRD + '</svg>';
    lane.appendChild(el);
    return el;
  }

  /* She shrinks on small screens, where 96px is a lot of bird. Re-sized on
     every crossing so a rotated phone gets the right size. */
  function size(el, scale) {
    var w = BASE_W * scale * (innerWidth < 720 ? 0.68 : 1);
    el.style.width = w + 'px';
    el.__w = w;
    el.__h = (w * 92) / 120;
  }

  /* A quadratic bezier, so the crossing arcs instead of running flat. */
  function at(f, p) {
    var mt = 1 - p, cx = (f.x0 + f.x1) / 2, cy = (f.y0 + f.y1) / 2 + f.dip;
    return {
      x: mt * mt * f.x0 + 2 * mt * p * cx + p * p * f.x1,
      y: mt * mt * f.y0 + 2 * mt * p * cy + p * p * f.y1
    };
  }

  function makeBird(i) {
    var el = hatch(CFG.sizes[i]), f = null;
    var tpath = CFG.thread ? tpaths[i] : null;

    function plan(dir, y0) {
      var pad = 220;
      return {
        dir: dir,
        x0: dir > 0 ? -pad : W + pad,
        x1: dir > 0 ? W + pad : -pad,
        y0: y0,
        y1: Math.max(60, Math.min(H - 110, y0 + (Math.random() * 0.3 - 0.15) * H)),
        dip: (Math.random() * 0.26 + 0.1) * H * (Math.random() < 0.5 ? -1 : 1),
        dur: CFG.speeds[i] + Math.random() * 1200,
        t0: performance.now() + CFG.stagger[i]
      };
    }

    return {
      /* the lead bird picks the heading; the others simply follow it */
      launch: function (dir, y0) {
        size(el, CFG.sizes[i]);
        f = plan(dir, y0 + (Math.random() * 0.1 - 0.05) * H);
      },
      done: function () {
        return f === null;
      },
      update: function (now) {
        if (!f) return;
        var p = (now - f.t0) / f.dur;
        if (p < 0) {
          el.style.opacity = 0; // still waiting to take off
          return;
        }
        if (p >= 1) {
          el.style.opacity = 0;
          f = null;
          if (tpath) tpath.setAttribute('d', '');
          return;
        }

        var pt = at(f, p), pv = at(f, Math.max(0, p - 0.012));
        el.style.opacity = 1;

        /* Measure the climb against |dx| so the angle stays within ±90°
           whichever way she travels — atan2 on a negative dx hands back
           about 180° and spins her onto her back. */
        var tilt = (Math.atan2(pt.y - pv.y, Math.abs(pt.x - pv.x) || 0.001) * 180) / Math.PI;
        tilt = Math.max(-20, Math.min(20, tilt));

        var face = f.dir > 0 ? -1 : 1; // she is drawn beak-left
        el.style.transform =
          'translate(' + (pt.x - el.__w / 2).toFixed(1) + 'px,' + (pt.y - el.__h / 2).toFixed(1) + 'px)' +
          ' scaleX(' + face + ') rotate(' + (-tilt).toFixed(2) + 'deg)';

        /* beat, then glide, then beat again */
        var phase = (p * 5.5) % 1;
        el.classList.toggle('pk-flap', phase < 0.55);
        el.classList.toggle('pk-glide', phase >= 0.55);

        if (tpath) {
          var d = '', N = 26;
          for (var k = 0; k <= N; k++) {
            var s = at(f, p * (k / N));
            d += (k ? 'L' : 'M') + s.x.toFixed(1) + ' ' + s.y.toFixed(1);
          }
          tpath.setAttribute('d', d);
        }
      }
    };
  }

  var flock = CFG.sizes.map(function (_, i) {
    return makeBird(i);
  });
  var waiting = null;

  function sendFlock() {
    clearTimeout(waiting);
    waiting = null;
    // A hidden tab would jump straight to the end of the arc; wait instead.
    if (document.hidden) {
      waiting = setTimeout(sendFlock, 2000);
      return;
    }
    measure();
    var dir = Math.random() < 0.5 ? 1 : -1;
    var y0 = H * (CFG.band[0] + Math.random() * (CFG.band[1] - CFG.band[0]));
    flock.forEach(function (b) {
      b.launch(dir, y0);
    });
    requestAnimationFrame(loop);
  }

  function loop(now) {
    var idle = true;
    for (var i = 0; i < flock.length; i++) {
      flock[i].update(now);
      if (!flock[i].done()) idle = false;
    }
    /* once the last one is off-screen, rest, then send them back */
    if (idle) {
      waiting = setTimeout(sendFlock, CFG.gapMin + Math.random() * CFG.gapVar);
      return;
    }
    requestAnimationFrame(loop);
  }

  addEventListener('resize', measure);
  measure();
  waiting = setTimeout(sendFlock, 1200);

  window.__pkBird = { launch: sendFlock };
})();
